var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { PrismicService } from '../prismic/prismic.service';
import { ActivatedRoute } from '@angular/router';
import { UiService } from '../ui/ui.service';
import { Project, Occurence } from '../interfaces/interfaces';
import { ProjectService } from '../project/project.service';
import { SliceService } from '../slice/slice.service';
import { OccurenceService } from '../occurence/occurence.service';
import { merge as mergeObservables, ReplaySubject, BehaviorSubject, Subject, fromEvent } from 'rxjs';
import { first, count, take, toArray, last, delay, debounceTime, distinctUntilChanged, map, mapTo, filter, merge, takeWhile, switchMap } from 'rxjs/operators';
var ProjectPageComponent = /** @class */ (function () {
    function ProjectPageComponent(projectService, sliceService, prismicService, occurenceService, activatedRoute, ui, elementRef) {
        var _this = this;
        this.projectService = projectService;
        this.sliceService = sliceService;
        this.prismicService = prismicService;
        this.occurenceService = occurenceService;
        this.activatedRoute = activatedRoute;
        this.ui = ui;
        this.elementRef = elementRef;
        this.occurences = [];
        this.occurencesDesc = [];
        this.timelineVisible = false;
        this.externalSelectedOccurenceAll$ = new Subject();
        this.internalSelectedOccurenceAll$ = new Subject();
        this.domLoadedOccurence$ = new ReplaySubject();
        this.domOffsets$ = new BehaviorSubject(null);
        this.fetchedOccurence$ = new ReplaySubject();
        this.clickedHeading$ = new Subject();
        this.destroyed = false;
        this.firstOccurenceOffset = Infinity;
        this.occurencesHeight = Infinity;
        this.externalSelectedOccurence$ = this.externalSelectedOccurenceAll$
            .pipe(distinctUntilChanged());
        this.externalSelectedOccurence$.subscribe(function (occurence) {
            _this.scrollToElementBySelector("#" + occurence.kebabName + " .occurence-scroll-padder");
        });
        this.scrollToHeading$ = mergeObservables(this.externalSelectedOccurence$.pipe(map(function (o) { return o.kebabName; })), this.clickedHeading$);
        // reset internalSelectedOccurence$ if externalSelectedOccurenceAll$ was triggered
        var reset = Math.PI;
        var reset$ = this.externalSelectedOccurenceAll$.pipe(mapTo(reset));
        this.internalSelectedOccurence$ = this.internalSelectedOccurenceAll$
            .pipe(merge(reset$), distinctUntilChanged(), filter(function (o) { return o !== reset; }));
        this.internalSelectedOccurence$.subscribe(function (o) { return _this._selectedOccurence = o; });
        this.fetchedOccurence$.pipe(first()).subscribe(function (o) { return _this._selectedOccurence = o; });
    }
    ProjectPageComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.activatedRoute.paramMap
                    .pipe(map(function (paramMap) { return paramMap.get('project_uid'); }))
                    .subscribe(function (projectUid) { return __awaiter(_this, void 0, void 0, function () {
                    var api, _a, fpo$;
                    var _this = this;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, this.prismicService.api()];
                            case 1:
                                api = _b.sent();
                                _a = this;
                                return [4 /*yield*/, this.projectService.getOne(projectUid)];
                            case 2:
                                _a.project = _b.sent();
                                this.ui.title$.next(this.project.name);
                                fpo$ = this.occurenceService.fetchProjectOccurences$(this.project);
                                fpo$.subscribe(function (occurence) {
                                    _this.fetchedOccurence$.next(occurence);
                                    _this.occurences.push(occurence);
                                });
                                fpo$.toPromise().then(function () {
                                    _this.fetchedOccurence$.complete();
                                    _this.occurencesDesc = _this.occurences.slice().reverse();
                                });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    ProjectPageComponent.prototype.ngAfterViewInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var native, n, occurences, lastScrollTime, scroll$, ignoringScroll, scrollToHeadingDone$;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.ui.whitened$.next(true);
                        native = this.elementRef.nativeElement;
                        this.textPartElement = native.querySelector('.text-part');
                        this.textPartContentElement = native.querySelector('.text-part-content');
                        return [4 /*yield*/, this.fetchedOccurence$.pipe(count(function (o) { return true; })).toPromise()];
                    case 1:
                        n = _a.sent();
                        return [4 /*yield*/, this.domLoadedOccurence$.pipe(take(n), toArray()).toPromise()];
                    case 2:
                        occurences = _a.sent();
                        this.recalculateDomOffsets();
                        lastScrollTime = new Date();
                        scroll$ = fromEvent(window, 'scroll').pipe(takeWhile(function () { return !_this.destroyed; }));
                        scroll$
                            .pipe(debounceTime(1000))
                            .subscribe(function () { return _this.recalculateDomOffsets(); });
                        ignoringScroll = false;
                        this.scrollToHeading$
                            .subscribe(function () { return ignoringScroll = true; });
                        scrollToHeadingDone$ = this.scrollToHeading$
                            .pipe(delay(100), merge(scroll$), debounceTime(500));
                        scrollToHeadingDone$.subscribe(function () { return ignoringScroll = false; });
                        // scroll$
                        //   .filter(event => ignoringScroll)
                        //   .filter(event => !this.timelineVisible)
                        //   .subscribe(event => this.timelineVisible = false);
                        scroll$
                            .pipe(filter(function (event) { return !ignoringScroll; }), switchMap(function (event) { return _this.domOffsets$; }), filter(function (domOffsets) { return !!domOffsets; }))
                            .subscribe(function (domOffsets) {
                            var d = window.scrollY;
                            _this.timelineVisible =
                                d > _this.firstOccurenceOffset - 100
                                    &&
                                        d < _this.firstOccurenceOffset + _this.occurencesHeight + 100;
                            var len = domOffsets.length;
                            // console.log(domOffsets, d);
                            for (var i = len - 1; i >= 0; i--) {
                                var y = domOffsets[i];
                                if (y - d < 100) {
                                    _this.internalSelectedOccurenceAll$.next(occurences[i]);
                                    break;
                                }
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ProjectPageComponent.prototype, "selectedOccurence", {
        get: function () {
            return this._selectedOccurence;
        },
        set: function (occurence) {
            if (!occurence)
                return;
            this._selectedOccurence = occurence;
            this.externalSelectedOccurenceAll$.next(occurence);
            // this.textPartElement.scrollTo(0, headerElement.offsetTop);
        },
        enumerable: true,
        configurable: true
    });
    ProjectPageComponent.prototype.humanizeStatus = function (status) {
        switch (status) {
            case 'finished':
                return 'Afgerond';
            case 'active':
                return 'Actief';
            case 'on_hold':
                return 'On hold';
        }
    };
    ProjectPageComponent.prototype.recalculateDomOffsets = function () {
        return __awaiter(this, void 0, void 0, function () {
            var mezr, n, headings, domOffsets, i, offset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mezr = require('mezr');
                        return [4 /*yield*/, this.fetchedOccurence$.pipe(count(function (o) { return true; })).toPromise()];
                    case 1:
                        n = _a.sent();
                        return [4 /*yield*/, this.domLoadedOccurence$.pipe(take(n)).toPromise()];
                    case 2:
                        _a.sent();
                        headings = this.textPartElement.querySelectorAll('.occurence-container');
                        domOffsets = [];
                        for (i = 0; i < n; i++) {
                            offset = mezr.offset(headings[i], this.textPartContentElement).top;
                            domOffsets[i] = offset;
                        }
                        this.domOffsets$.next(domOffsets);
                        this.recalculateFirstOccurenceOffset();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectPageComponent.prototype.recalculateFirstOccurenceOffset = function () {
        this.firstOccurenceOffset = this.elementRef.nativeElement.querySelector('.occurences').offsetTop;
        this.occurencesHeight = this.elementRef.nativeElement.querySelector('.occurences').clientHeight;
    };
    ProjectPageComponent.prototype.registerLoadedOccurence = function (occurence) {
        this.domLoadedOccurence$.next(occurence);
    };
    ProjectPageComponent.prototype.clickMedia = function () {
        var _this = this;
        this.fetchedOccurence$.pipe(last(), take(1)).subscribe(function (o) { return _this.internalSelectedOccurenceAll$.next(o); });
        this.clickedHeading$.next('media');
        this.scrollToElementBySelector('#media');
    };
    ProjectPageComponent.prototype.clickGallery = function () {
        var _this = this;
        this.fetchedOccurence$.pipe(last(), take(1)).subscribe(function (o) { return _this.internalSelectedOccurenceAll$.next(o); });
        this.clickedHeading$.next('gallery');
        this.scrollToElementBySelector('#gallery');
    };
    ProjectPageComponent.prototype.scrollToElementBySelector = function (selector) {
        var element = this.elementRef.nativeElement.querySelector(selector);
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    ProjectPageComponent.prototype.ngOnDestroy = function () {
        this.externalSelectedOccurenceAll$.complete();
        this.internalSelectedOccurenceAll$.complete();
        this.domLoadedOccurence$.complete();
        this.clickedHeading$.complete();
        this.destroyed = true;
        this.ui.whitened$.next(false);
    };
    return ProjectPageComponent;
}());
export { ProjectPageComponent };
//# sourceMappingURL=project-page.component.js.map